import { Box, Text } from "@okshaun/components";
import type { ReactNode } from "react";

interface RailSectionProps {
  title: string;
  meta?: string;
  scope?: string;
  onClear?: () => void;
  /** Extra header content on the right, e.g. a link to another page. */
  action?: ReactNode;
  /** Cap the panel at 560px and scroll inside it. */
  scroll?: boolean;
  children: ReactNode;
}

/** Shared frame for the right-rail panels: uppercase mono title, optional scope + clear. */
export function RailSection({
  title,
  meta,
  scope,
  onClear,
  action,
  scroll,
  children,
}: RailSectionProps) {
  return (
    <Box as="section" display="flex" flexDir="column" gap="8" minW="0">
      <Box display="flex" alignItems="baseline" gap="10" px="12">
        <Text
          textStyle="mono.xs"
          color="text.subtlest"
          letterSpacing="widest"
          textTransform="uppercase"
        >
          {title}
        </Text>
        {scope && (
          <Text fontSize="13" fontWeight="semibold" color="text.bold">
            {scope}
          </Text>
        )}
        {meta && (
          <Text textStyle="mono.xs" color="text.subtlest">
            {meta}
          </Text>
        )}
        {action && <Box ml="auto">{action}</Box>}
        {onClear && (
          <Text
            as="button"
            textStyle="mono.xs"
            color="text.subtlest"
            ml={action ? undefined : "auto"}
            bg="transparent"
            border="none"
            cursor="pointer"
            onClick={onClear}
          >
            clear ✕
          </Text>
        )}
      </Box>
      <Box
        bg="surface"
        border="default"
        borderRadius="8"
        p="6"
        display="flex"
        flexDir="column"
        gap="2"
        maxH={scroll ? "[560px]" : undefined}
        overflowY={scroll ? "auto" : "visible"}
      >
        {children}
      </Box>
    </Box>
  );
}
